// Operating-area vocabulary: SADC countries + South African provinces only
// (down to province level — not cities).
// Used by the subbie profile pill-input AND the admin Live Map coverage highlight.

export const OPERATING_AREA_SUGGESTIONS = [
  'Gauteng', 'KwaZulu-Natal', 'Western Cape', 'Eastern Cape', 'Limpopo',
  'Mpumalanga', 'North West', 'Free State', 'Northern Cape',
  'South Africa', 'Zimbabwe', 'Mozambique', 'Botswana', 'Namibia',
  'Lesotho', 'Eswatini', 'Zambia', 'Malawi', 'Angola', 'Tanzania',
  'DR Congo', 'Madagascar', 'Mauritius', 'Seychelles', 'Burundi', 'Rwanda'
];

// Province -> district/metro names exactly as they appear in public/data/sa-provinces.geojson
export const PROVINCE_DISTRICTS = {
  'Gauteng': ['City of Johannesburg Metropolitan', 'City of Tshwane Metropolitan', 'Ekurhuleni Metropolitan', 'Sedibeng District', 'West Rand District'],
  'KwaZulu-Natal': ['Amajuba District', 'eThekwini Metropolitan', 'iLembe District', 'Sisonke District', 'Ugu District', 'uMgungundlovu District', 'Umkhanyakude District', 'Umzinyathi District', 'Uthukela District', 'uThungulu District', 'Zululand District'],
  'Western Cape': ['Cape Winelands District', 'Central Karoo District', 'City of Cape Town', 'Eden District', 'Overberg District', 'West Coast District'],
  'Eastern Cape': ['Alfred Nzo District', 'Amathole District', 'Buffalo City Metropolitan', 'Chris Hani District', 'Joe Gqabi District', 'Nelson Mandela Bay Metropolitan', 'O.R. Tambo District', 'Sarah Baartman District'],
  'Limpopo': ['Capricorn District', 'Sekhukhune District', 'Mopani District', 'Vhembe District', 'Waterberg District'],
  'Mpumalanga': ['Ehlanzeni District', 'Gert Sibande District', 'Nkangala District'],
  'North West': ['Bojanala Platinum District', 'Dr Kenneth Kaunda District', 'Dr Ruth Segomotsi Mompati District', 'Ngaka Modiri Molema District'],
  'Free State': ['Fezile Dabi District', 'Lejweleputswa District', 'Mangaung Metropolitan', 'Thabo Mofutsanyana District', 'Xhariep District'],
  'Northern Cape': ['Frances Baard District', 'John Taolo Gaetsewe District', 'Namakwa District', 'Pixley ka Seme District', 'ZF Mgcawu District']
};

// Pill name -> name as found in public/data/world-countries.geojson (Natural Earth 110m)
export const COUNTRY_ALIASES = {
  'DR Congo': 'Dem. Rep. Congo'
};

// Converts operating-area pills into the feature-name sets used to match the boundary GeoJSONs.
export function operatingAreaMatches(areas) {
  const provinces = new Set();
  const countries = new Set();
  const list = Array.isArray(areas)
    ? areas
    : String(areas || '').split(',');
  list.forEach((raw) => {
    const a = String(raw || '').trim();
    if (!a) return;
    const dists = PROVINCE_DISTRICTS[a];
    if (dists) {
      dists.forEach((d) => provinces.add(d.toLowerCase()));
      return;
    }
    countries.add((COUNTRY_ALIASES[a] || a).toLowerCase());
  });
  return { provinces, countries };
}
